import styled, { css } from 'styled-components';
import { topbarHeight } from '@styles/layout';
import { violet } from '@styles/colors';
import { Link, LinkProps } from '@components/Link/Link';

export const ctaBorderSize = 2;
export const ctaFixVerticalAlign = 2;

type CtaProps = LinkProps & {
  isActive?: boolean;
};

export const Cta = styled(Link)`
  vertical-align: middle;
  display: inline-block;
  border: ${ctaBorderSize}px solid ${violet};
  line-height: ${topbarHeight * 0.6}px;
  font-weight: 600;
  text-decoration: none;
  color: ${(props: CtaProps) => props.isActive ? 'white' : violet};
  font-size: 1rem;
  cursor: pointer;
  padding: 0 2rem;
  text-transform: uppercase;
  transition-duration: .3s;
  padding-top: ${ctaFixVerticalAlign}px;
  ${(props: CtaProps) => props.isActive ? css`background: ${violet};` : ''}

  &:hover {
    background: ${violet};
    color: white;
  }
`;


// WEBPACK FOOTER //
// src/app/src/components/Cta/Cta.s.ts